import { isSetAccessToken } from "./AccessToken";

export const format_price_number = (price:number|string) => {
    return price.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ");
}

export const isUserLogged = () => {
    if (("xf_active_user" in sessionStorage) && isSetAccessToken()) {
        return true
    }
    return false
}